class TSBundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dynamicData = JSON.parse(this.querySelector("[data-dynamic-data]").textContent);
    this.totalQuantity = 0;
    this.quantityRate = 1;
    this.quantityRatePercentage = "";

    this.addEventListener("change", this.onQuantityUpdate.bind(this))
    this.onQuantityUpdate();
    this.initClickEvent();
    this.toggleSubscriptionPostionInit();
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "quantity-decrease":
          case "quantity-increase":
            const product = e.target.closest("[data-product]");
            const quantityInput = product.querySelector('[name="quantity"]');
            let quantityInputValue = parseInt(quantityInput.value);

            if (e.target.getAttribute("data-action") === "quantity-decrease") {
              quantityInputValue--;
            } else {
              quantityInputValue++;
            }

            if (quantityInputValue == 0) {
              product.querySelector("[data-quantity]").innerHTML = "";
            } else {
              product.querySelector("[data-quantity]").innerHTML = quantityInputValue;
            }

            quantityInput.value = quantityInputValue;
            product.classList.toggle("active", quantityInputValue !== 0);
            this.onQuantityUpdate();
            break;
          case "add-cart":
            if (this.getAttribute("data-quantity") !== "0") {
              this.addToCart();
            }
            break;
          case "toggle-summary":
            const summaryList = this.querySelector("[data-total-list]");
            e.target.classList.toggle("active");
            
            summaryList.style.maxHeight = summaryList.scrollHeight + "px";

            if (e.target.classList.contains("active")) {
              setTimeout(() => {
                summaryList.style.maxHeight = "unset";
              }, 350);
            } else {
              setTimeout(() => {
                summaryList.style.maxHeight = null;
              }, 50);
            }

            if (window.innerWidth < 750) {
              const subscriptionToggle = this.querySelector("[data-action=\"toggle-subscription\"]");
              const subscriptionList = this.querySelector("[data-subscription]");
              subscriptionToggle.classList.remove("active");
              subscriptionList.style.maxHeight = null;
              document.documentElement.style.overflow = null;
            }
            break;
          case "toggle-subscription":
            const subscriptionList = this.querySelector("[data-subscription]");
            e.target.classList.toggle("active");
            subscriptionList.style.maxHeight = e.target.classList.contains("active") ? subscriptionList.scrollHeight + "px" : null;

            if (e.target.classList.contains("active")) {
              document.documentElement.style.overflow = "hidden";
            } else {
              document.documentElement.style.overflow = null;
            }

            if (window.innerWidth < 750) {
              const summaryToggle = this.querySelector("[data-action=\"toggle-summary\"]");
              const summaryList = this.querySelector("[data-total-list]");
              summaryToggle.classList.remove("active");
              summaryList.style.maxHeight = summaryList.scrollHeight + "px";
              setTimeout(() => {summaryList.style.maxHeight = null}, 50);
            }
            break;
        }
      }
    })
  }

  onQuantityUpdate() {
    const sellingType = this.querySelector('[name="selling_type"]:checked').value;
    const sellingPlanTitle = this.querySelector('[name="selling_plan"]:checked').dataset.name;

    const totalProductList = this.querySelector("[data-total-list]");
    const productList = this.querySelector("[data-product-list]");

    let totalPrice = 0;
    let totalSellingPrice = 0;
    let totalCompare = 0;

    totalProductList.innerHTML = "";

    this.totalQuantity = 0;

    productList.querySelectorAll('[data-product] [name="quantity"]').forEach(quantityInput => {  
      this.totalQuantity += parseInt(quantityInput.value);

      if (this.totalQuantity == 2) {
        this.quantityRate = 0.8; 
        this.quantityRatePercentage = "20%"
      } else if (this.totalQuantity == 3) {
        this.quantityRate = 0.75; 
        this.quantityRatePercentage = "25%"
      } else if (this.totalQuantity == 4) {
        this.quantityRate = 0.7; 
        this.quantityRatePercentage = "30%"
      } else if (this.totalQuantity >= 5) {
        this.quantityRate = 0.65; 
        this.quantityRatePercentage = "35%"
      } else {
        this.quantityRate = 1; 
        this.quantityRatePercentage = ""
      }
    })

    productList.querySelectorAll("[data-product]").forEach(product => {
      const productData = this.dynamicData.find(obj => obj.id === parseInt(product.dataset.product));
      const quantityInput = product.querySelector('[name="quantity"]');
      const quantityInputValue = parseInt(quantityInput.value);
      const selectedProductAllocation = productData.sellingPlans.find(obj => obj.name === sellingPlanTitle);
      let productPrice = productData.price;
      let productCompare = productData.compare;

      if (quantityInputValue > 0) {
        const li = this.createBundleItem(productData, quantityInputValue, sellingType);
        totalProductList.appendChild(li);
      }

      if (sellingType === "subscribe") {
        productPrice = selectedProductAllocation.price;
        productCompare = selectedProductAllocation.compare;
      }

      totalPrice += productData.price * quantityInputValue;
      totalSellingPrice += selectedProductAllocation.price * quantityInputValue;
      totalCompare += productData.compare * quantityInputValue;

      product.querySelector("[data-price]").innerHTML = this.formatShopifyPrice(productPrice * this.quantityRate);
      product.querySelector("[data-save]").innerHTML = this.quantityRatePercentage;

      if (this.quantityRate < 1) {
        product.querySelector("[data-compare]").innerHTML = this.formatShopifyPrice(productPrice);
      } else {
        product.querySelector("[data-compare]").innerHTML = "";
      }

      product.setAttribute("data-selling-plan", selectedProductAllocation.id);
    })

    const oneTimeOption = this.querySelector(".ts-subscription-v3__option--onetime");
    const oneTimeOptionPriceEl = oneTimeOption.querySelector(".ts-subscription-v3__option-price--main");
    const oneTimeOptionCompareEl = oneTimeOption.querySelector(".ts-subscription-v3__option-price--compare");

    const subscribeOption = this.querySelector(".ts-subscription-v3__option--subscribe");
    const subscribeOptionPriceEl = subscribeOption.querySelector(".ts-subscription-v3__option-price--main");
    const subscribeOptionCompareEl = subscribeOption.querySelector(".ts-subscription-v3__option-price--compare");

    if (totalPrice === 0) {
      totalPrice = this.dynamicData[0].price;
      totalSellingPrice = this.dynamicData[0].sellingPlans[0].price;
      totalCompare = this.dynamicData[0].compare;
    }

    let totalDiscount = 0;
    
    if (sellingType === "subscribe") {
      totalDiscount = totalPrice - (totalSellingPrice * this.quantityRate);
    } else {
      totalDiscount = totalPrice - (totalPrice * this.quantityRate);
    }

    this.setAttribute("data-subscribe", sellingType);

    const subscriptionList = this.querySelector("[data-subscription]");
    const subscriptionToggle = subscriptionList.previousElementSibling;
    const selectedSubscriptionLabel = subscriptionToggle.querySelector("[data-selected]");

    // Labels come from the section settings via window.tsBundleStrings so the
    // toggle keeps the shopper's language. English defaults are the fallback.
    const bundleStrings = window.tsBundleStrings || {};
    if (sellingType === "subscribe") {
      selectedSubscriptionLabel.innerHTML = bundleStrings.subscribeLabel || "Subscribe"
    } else {
      selectedSubscriptionLabel.innerHTML = bundleStrings.onetimeLabel || "One-time"
    }

    this.querySelector("[data-discount]").innerHTML = "-" + this.formatShopifyPrice(totalDiscount);

    oneTimeOptionPriceEl.innerHTML = this.formatShopifyPrice(totalPrice * this.quantityRate);
    subscribeOptionPriceEl.innerHTML = this.formatShopifyPrice(totalSellingPrice * this.quantityRate);
    subscribeOptionCompareEl.innerHTML = this.formatShopifyPrice(totalPrice);

    if (this.quantityRate < 1) {
      oneTimeOptionCompareEl.innerHTML = this.formatShopifyPrice(totalPrice);
    } else {
      oneTimeOptionCompareEl.innerHTML = "";
    }
    
    this.setAttribute("data-quantity", this.totalQuantity);
  }

  createBundleItem(productData, quantity = 1, sellingType) {
    const li = document.createElement('li');
    const sellingPlanTitle = this.querySelector('[name="selling_plan"]:checked').dataset.name;
    const selectedProductAllocation = productData.sellingPlans.find(obj => obj.name === sellingPlanTitle);

    let productPrice = productData.price;
    let productCompare = productData.compare;

    if (sellingType === "subscribe") {
      productPrice = selectedProductAllocation.price;
      productCompare = selectedProductAllocation.compare;
    }
    
    if (this.quantityRate < 1) {
      productCompare = this.formatShopifyPrice(productPrice);
    } else {
      productCompare = "";
    }

    li.innerHTML = `
      <div 
        class="ts-bundle-builder__total-item"
        style="--upsell-background: ${productData.imageBackground};"
      >
        <div class="ts-bundle-builder__total-item-media">
          <img src="${productData.imageUrl}" width="200" height="200" alt="">
        </div>

        <div class="ts-bundle-builder__total-item-content">
          <div class="ts-bundle-builder__total-item-headings">
            <p class="ts-bundle-builder__total-item-title">
              <span>${productData.title}</span>
            </p>

            <p class="ts-bundle-builder__total-item-details"></p>
          </div>

          <div class="ts-bundle-builder__total-item-controls">
            <div class="ts-bundle-builder__total-item-price">
              <span class="ts-bundle-builder__total-item-save">${this.quantityRatePercentage}</span>
              <span data-compare>${productCompare}</span>
              <span>${this.formatShopifyPrice(productPrice * this.quantityRate)}</span>
            </div>

            <p class="ts-bundle-builder__total-item-quantity">x${quantity}</p>
          </div>
        </div>
      </div>
    `;

    return li;
  }

  formatShopifyPrice(cents) {
    const template = window.shopMoneyFormat;
    const amount = (cents / 100).toFixed(2);
    const [int, dec] = amount.split('.');

    const replacements = {
      '{{amount}}': amount,
      '{{amount_no_decimals}}': Math.round(cents / 100),
      '{{amount_with_comma_separator}}': `${int},${dec}`,
      '{{amount_no_decimals_with_comma_separator}}': int,
    };

    let formatted = template;

    for (const key in replacements) {
      formatted = formatted.replace(key, replacements[key]);
    }

    return formatted;
  }

  addToCart() {
    const sellingType = this.querySelector('[name="selling_type"]:checked').value;
    const productList = this.querySelector("[data-product-list]");
    const cartData = {
      items: [],
      attributes: {
        _bundle: 'true'
      }
    };

    let currentDiscount = "";

    if (this.totalQuantity >= 5) {
      currentDiscount = "SAVE 35%";
    } else if (this.totalQuantity == 4) {
      currentDiscount = "SAVE 30%";
    } else if (this.totalQuantity == 3) {
      currentDiscount = "SAVE 25%";
    } else if (this.totalQuantity == 2) {
      currentDiscount = "SAVE 20%";
    }

    productList.querySelectorAll("[data-product]").forEach(product => {
      const quantityInput = product.querySelector('[name="quantity"]');
      const quantityInputValue = parseInt(quantityInput.value);
      let cartItemData = {
        id: parseInt(product.dataset.product),
        quantity: quantityInputValue
      }

      if (sellingType === "subscribe") {
        cartItemData["selling_plan"] = parseInt(product.getAttribute("data-selling-plan"));
      }

      if (quantityInputValue > 0) {
        cartData.items.unshift(cartItemData);
      }
    })

    if (this.dataset.gift && this.totalQuantity > 1 && sellingType === "subscribe") {
      cartData.items.unshift({
        id: parseInt(this.dataset.gift),
        quantity: 1
      });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: currentDiscount
          })
        })
        .then(response => response.json())
        .then(response => {
          if (!response.items) {
            const error = new Error(response.description);
            throw error;
          } else {
            window.upcartRefreshCart()
            window.upcartOpenCart();
          }
        })
        .catch(error => console.error(error));
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.classList.remove("loading"));
  }

  toggleSubscriptionPostionInit() {
    const subscribptionBlock = this.querySelector(".ts-bundle-builder__subscription");
    const mobileControlsBlock = this.querySelector(".ts-bundle-builder__total");
    const progressBlock = this.querySelector(".ts-bundle-builder__progress-block");

    const toggleSubscriptionPostion = () => {
      if (window.innerWidth >= 750) {
        progressBlock.after(subscribptionBlock);
      } else {
        mobileControlsBlock.prepend(subscribptionBlock);
      }      
    }

    toggleSubscriptionPostion();
    window.addEventListener('resize', toggleSubscriptionPostion);
  }
}

customElements.define("ts-bundle-builder", TSBundleBuilder);